import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class ObjectionSuggestionReportService {

  constructor(public httpClient: HttpClient) { }
  //load board rest
 
  //

  //load grievance rest with board id
  async loadForOSReport(data: any) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadForOSReport, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

     //static
     async loadObjectioSuggestions(data: any) {
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadOsTypeBybdid,data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //

     //load board rest
     async loadBoard() {
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadBoard, {})
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //


    //load departments type rest
  async loadDepartments(boardId: any) {
    const data = { 'bdId': boardId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load departments type rest
  async loadReportData() {
    return new Promise((resolve) => {
      this.httpClient
      .post(ApiUrls.loadOSForReport, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

}
